<div fxLayout="column">
  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <!-- Column Definition: displayName -->
      <ng-container matColumnDef="displayName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'announcement.name' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.displayName }}</td>
      </ng-container>

      <!-- Column Definition: description -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'announcement.description' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.description }}</td>
      </ng-container>

      <!-- Column Definition: actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button *ngIf="(playing$ | async) !== row.fileName" (click)="play(row)">
            <mat-icon matTooltip="{{ 'announcement.play' | translate }}">play_arrow</mat-icon>
          </button>
          <button mat-icon-button *ngIf="(playing$ | async) === row.fileName" (click)="stop()">
            <mat-icon matTooltip="{{ 'announcement.stop' | translate }}">stop</mat-icon>
          </button>
          <button mat-icon-button (click)="download(row)">
            <mat-icon matTooltip="{{ 'announcement.download' | translate }}">save_alt</mat-icon>
          </button>
          <ng-container *ngIf="!global">
            <button mat-icon-button (click)="openAnnouncementDialog(row)" matTooltip="{{ 'global.edit' | translate }}">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button (click)="openDeleteDialog(row)" matTooltip="{{ 'global.delete' | translate }}">
              <mat-icon>delete</mat-icon>
            </button>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 25, 100]" (page)="paging($event)"></mat-paginator>
  </div>
  <div *ngIf="!global" fxLayout="row" fxLayoutAlign="end center">
    <button mat-button (click)="openAnnouncementDialog()" color="primary">
      {{ 'announcement.upload_new_btn' | translate }}
    </button>
  </div>
</div>
